export default __webpack_public_path__ + "static/media/ジン.258d4907.PNG";